import { singleConfiguratorAjaxRequest } from './rotoclear-ajax.js';
import { recursiveClassToggler } from './rotoclear-recursive-class.js';
const COUNTRY_FIELDS = ['.widget-select.select.country', '.widget-select.select.shipping_country'];
function registerEventHandlers() {

  // get all Configurators
  const configurators = document.querySelectorAll('.module-rotoclear-single-configurator');
  console.log('Found configurators:', configurators.length);
  configurators.forEach(configurator => {
    // get the contact form element
    const registerEventListeners = (contactForm) => {
      // Register change listeners for country to update districts
      const countryFields = contactForm.querySelectorAll(COUNTRY_FIELDS.join(','));
      countryFields.forEach(countryWidget => {
        const districtWidget = countryWidget.nextElementSibling;
        registerCountryChangeListener(countryWidget, districtWidget);
      });
      // Register change listener for the different shipping address checkbox
      const differentShippingAddressCheckbox = contactForm.querySelector('.widget.different_shippingaddress input[type="checkbox"]');
      if (differentShippingAddressCheckbox) {
        differentShippingAddressCheckbox.addEventListener('change', handleDifferentShippingAddressCheckbox);
        // Initial call to set the visibility of shipping address fields based on the checkbox state
        handleDifferentShippingAddressCheckbox({ target: differentShippingAddressCheckbox });
      } else {
        console.warn('Different shipping address checkbox not found in contact form:', contactForm);
      }
    }

    const registerCountryChangeListener = (countryWidget, districtWidget) => {
      const select = countryWidget.querySelector('select');
      if (!select) {
        console.warn('No select element found in country widget:', countryWidget);
        return;
      }
      select.addEventListener('change', function (event) {
        handleCountryChange(event, countryWidget, districtWidget);
      });
      handleCountryChange({ target: select }, countryWidget, districtWidget); // Initial call to set districts based on the current country
    }


    const handleCountryChange = (event, countryWidget, districtWidget) => {
      const handleCountryRequestSuccess = (response) => {
        console.log('Country districts loaded successfully:', response);
        const districtSelect = districtWidget.querySelector('select');
        districtSelect.innerHTML = ''; // Clear existing options
        const responseJson = JSON.parse(response.responseText);
        if (!responseJson) {
          return;
        }
        
        districtSelect.required = responseJson.exists;
        recursiveClassToggler(districtWidget, 'hidden', !responseJson.exists);
        // Set new districts if they exist
        if (responseJson.exists) {
          responseJson.districts.options.forEach(district => {
            const option = document.createElement('option');
            option.value = district.shortcode;
            option.textContent = district.state;
            districtSelect.appendChild(option);
          });
        }

      }
      const handleCountryRequestError = (error) => {
        console.error('Error loading country districts:', error);
      }
      const selectedCountry = event.target.value;
      // Check if we have districts for the selected country
      if (selectedCountry) {
        singleConfiguratorAjaxRequest('state_districts', 'GET', {
          country: selectedCountry,
        }, handleCountryRequestSuccess, handleCountryRequestError);
      }
    }

    const handleDifferentShippingAddressCheckbox = (event) => {
      const shippingAddressFields = contactForm.querySelectorAll('.shipping');
      const checked = event.target.checked;
      shippingAddressFields.forEach(field => {
        recursiveClassToggler(field, 'hidden', !checked);
        // Make inputs required if the checkbox is checked
        field.querySelectorAll('input, select').forEach(input => {
          input.required = checked;
        });
      });
      if (checked) {
        const countryWidget = contactForm.querySelector('.widget-select.select.shipping_country');
        const select = countryWidget.querySelector('select');
        const districtWidget = contactForm.querySelector('.widget-select.select.shipping_state_district');
        // Find shipping country and district widgets
        handleCountryChange({ target: select }, countryWidget, districtWidget);
      }
    };
    const contactForm = configurator.querySelector('.content-rotoclear-contact');
    console.log('Contact form found:', contactForm);
    if (contactForm) {
      registerEventListeners(contactForm);
    }



  });
}
document.addEventListener('DOMContentLoaded', function () {
  registerEventHandlers();
});